// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class SByte implements flatbuffers.IUnpackableObject<SByteT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SByte {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSByte(bb: flatbuffers.ByteBuffer, obj?: SByte): SByte {
    return (obj || new SByte()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSByte(bb: flatbuffers.ByteBuffer, obj?: SByte): SByte {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SByte()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : 0;
  }

  static startSByte(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldInt8(0, value, 0);
  }

  static endSByte(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createSByte(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    SByte.startSByte(builder);
    SByte.addValue(builder, value);
    return SByte.endSByte(builder);
  }

  unpack(): SByteT {
    return new SByteT(this.value());
  }

  unpackTo(_o: SByteT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): SByteT {
    const t = new SByteT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class SByteT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return SByte.createSByte(builder, this.value);
  }

  clone(): SByteT {
    const obj = new SByteT();
    obj.value = this.value;
    return obj;
  }

  equals(other: SByteT): boolean {
    if (this.value !== other.value) return false;
    return true;
  }
}

export function verifySByte(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
  } finally {
    verifier.popDepth();
  }
}
